import { useSyncExternalStore } from 'react';

/**
 * Which segment dashboards are open in edit mode in this tab. The page builder edits a local
 * draft, so a widget placed onto the same segment from elsewhere (e.g. Add to Dashboard from the
 * chat drawer) would be overwritten by the next save — the placement modal checks this and asks
 * the user to finish editing first.
 */
const editing = new Set<string>();
const listeners = new Set<() => void>();

const keyOf = (projectId: number, segmentId: number) => `${projectId}:${segmentId}`;

export function setSegmentEditing(projectId: number, segmentId: number, isEditing: boolean): void {
  const key = keyOf(projectId, segmentId);
  if (isEditing === editing.has(key)) return;
  if (isEditing) editing.add(key);
  else editing.delete(key);
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useIsSegmentEditing(projectId: number, segmentId: number | null): boolean {
  return useSyncExternalStore(subscribe, () => segmentId != null && editing.has(keyOf(projectId, segmentId)));
}
